import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PostInfo } from '@mommy/models/PostInfo.model';

@Component({
  selector: 'app-video-post-list',
  templateUrl: './video-post-list.component.html',
  styleUrls: ['./video-post-list.component.scss'],
})
export class VideoPostListComponent implements OnInit {
  @Output() postOnClick = new EventEmitter<PostInfo>();

  _post: PostInfo;
  _feature_image;

  constructor() {}

  ngOnInit() {}

  get post(): any {
    return this._post;
  }

  @Input() set post(value: any) {
    if (value) {
      this._post = value;
      this._feature_image =
        `url(${value.post_feature_image_url})` +
        ', url(assets/img3/default/video_default.png)';

      console.log('video _post', value);
    } else {
      this._post = {};
    }
  }

  postClick() {
    this.postOnClick.emit(this._post);
  }
}
